export default __webpack_public_path__ + "static/avatar-646fde758e61848782a7c0af175ee231.webp";